import React from "react";
import AboutAreaTwo from "../components/AboutAreaTwo";
import BannerTwo from "../components/BannerTwo";
import FooterTwo from "../components/FooterTwo";
import NavbarTwo from "../components/NavbarTwo";
import WorkProcessTwo from "../components/WorkProcessTwo";
import BrandAreaOne from "../components/BrandAreaOne";
import ServiceAreaOne from "../components/ServiceAreaOne";
import FaqAreaOne from "../components/FaqAreaOne";
import ContactAreaFour from "../components/ContactAreaFour";
import PartnerShipArea from "../components/PartnerShipArea";
import AboutAreaFive from "../components/AboutAreaFive";
import AboutUs from "../components/HnaM3ak/AboutUs";
import ProcessusDePriseEnCharge from "../components/HnaM3ak/ProcessusDePriseEnCharge";
import IntervenantsSection from "../components/HnaM3ak/IntervenantsSection";
// import Footer from "../components/HnaM3ak/Footer";
import UNFMNavbar  from "./ENFM/Navbar/UNFMNavbar";
import UNFMHero from "./ENFM/Hero/UNFMHero";
import ProblemSection from "./ENFM/ProblemSection/ProblemSection";
import SharedFileSection from "./ENFM/SharedFileSection/SharedFileSection";
import TimelineSection from "./ENFM/TimelineSection/TimelineSection";
import FeaturesSection from "./ENFM/FeaturesSection/FeaturesSection";
import ActorsSection from "./ENFM/ActorsSection/ActorsSection";
import SecuritySection from "./ENFM/SecuritySection/SecuritySection";
import NetworkSection from "./ENFM/NetworkSection/NetworkSection";
import ImpactSection from "./ENFM/ImpactSection/ImpactSection";
import CtaSection from "./ENFM/CtaSection/CtaSection";
import Footer from "./ENFM/Footer/Footer";

const HomeTwo = () => {
  return (
    <>

    
      {/* Navigation Bar Two*/}
      <UNFMNavbar  />
      {/* <NavbarTwo /> */}

      {/* Hero Area Two */}
      <UNFMHero />

      <ProblemSection />

      <SharedFileSection />

      <TimelineSection />

      <FeaturesSection />

      <ActorsSection />

      <SecuritySection />

      <NetworkSection />

      <ImpactSection />

      <CtaSection />

      <Footer />

      {/* Banner Two */}
      {/* <BannerTwo /> */}

      {/* <WorkProcessTwo /> */}
      


      {/* About Area Two */}
      {/* <AboutAreaTwo /> */}
      {/* <AboutUs/> */}


      {/* <ProcessusDePriseEnCharge/> */}


      

      {/* Service Area One */}
      {/* <ServiceAreaOne /> */}

      {/* FAQ Area One */}
      {/* <FaqAreaOne /> */}

      {/* About Area Two */}
      {/* <ServiceAreaTwo /> */}
      {/* Pricing Area Two */}
      {/* <PricingAreaTwo /> */}

      {/* Counter Area Two */}
      {/* <CounterAreaTwo /> */}

      {/* Contact Area Two */}
      {/* <ContactAreaTwo /> */}

      {/* Work Process Two */}

      {/* <WorkProcessTwo /> */}

      {/* Testimonial One */}
      {/* <TestimonialOne /> */}

      {/* Contact Area Four */}
      {/* <ContactAreaFour /> */}

      {/* <PartnerShipArea /> */}

      {/* Blog Area Two */}
      {/* <BlogAreaTwo /> */}

      {/* <IntervenantsSection/> */}

      {/* <BrandAreaOne /> */}

      {/* Footer Two */}
      {/* <Footer /> */}
    </>
  );
};

export default HomeTwo;
